/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Male
 *
 * 2 = Female
 */
export enum IndividualApplicantGender {
  Male = 1,
  Female = 2,
}
